const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, '') + 'Api'] = { ...files(key) }
})

module.exports = modules
